<div class="container my-4">
    <div class="row">
      <div class="col-12 ">
        <span class="title_header_bar">New User</span>
      </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="searchform">

      <div class="row d-flex justify-content-start align-items-center flex-wrap grid-margin">
        <div [ngClass]="unencryexport?'col-md-6':'col-3'">
          <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
            <i class="fa fa-refresh"></i> Refresh
          </button> -->
          <app-button (refreshClicked)="clearFilter()"></app-button>
          <button type="button" class="btn excel_btn text-nowrap mr-2" (click)="exportAsXLSX(false)">
            <i class="fa fa-file-excel"></i> Export
          </button>
          <button type="button" class="btn excel_btn text-nowrap mr-2" (click)="exportAsXLSX(true)" *ngIf="unencryexport">
            <i class="fa fa-file-excel"></i> UnEncrypted Export
          </button>
        </div>
        <div class="col-md-4 ml-5 padd-right-file" style="display: flex;">
          <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'"
            style="margin-bottom: 1rem !important;">
            <mat-label>Search</mat-label>
            <div class="search-input-container">
              <input placeholder="Enter Name / ContactN0 / Name / Email" id="search" matInput formControlName="SearchQuery"
               type="text" #searchInput>
            </div>
          </mat-form-field>
          <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
            (click)="search()">
            <mat-icon style="color: white;">search</mat-icon>
          </button>
        </div>
      </div>
      </form>

      <div class="table-responsive mt-2 mb-4">
        <mat-table #table [dataSource]="dataSource" >

          <ng-container matColumnDef="FirstName">
            <mat-header-cell *matHeaderCellDef >First Name</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign"> {{dataField.firstName}}</p>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="LastName">
            <mat-header-cell *matHeaderCellDef >Last Name</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign">{{dataField.lastName}}</p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="ContactNO">
            <mat-header-cell *matHeaderCellDef > ContactNo</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign">{{dataField.mobileNumber}} </p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="Email">
            <mat-header-cell *matHeaderCellDef >Email</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign">{{dataField.email}}</p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="CreatedOn">
            <mat-header-cell *matHeaderCellDef >Created On</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign">{{dataField.creationTs |date:'yyyy/MM/dd H:mm'}}</p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef >Status</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <p class="text-truncate txtalign">{{dataField.userStatusTypeName}}</p>
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef >Action</mat-header-cell>
            <mat-cell *matCellDef="let dataField">
              <div class="text-truncate text-center">

                <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-trash-can"
                  (click)="deleteProduct(dataField)"></i>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

          <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
          </mat-row>
        </mat-table>
      </div>
      <div *ngIf="dataSource.filteredData.length === 0" 
      class="no-data-message" >
      <p>No data found</p>
      </div>

      <div class="table_pagenation">
        <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length" [pageIndex]="0"
          [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
        </mat-paginator>
      </div>

    </div>
  </div>
